import pkg from '../../package.json';

export default {
  connected: false,
  authenticated: false,
  coverIframes: false,
  fullscreenIframe: false,
  newVersionAvailable: false,
  onViz: false,
  onAiDash: false,
  initialPath: '',
  packageVersion: pkg.version,
  drawer: true,
  rail: false,
  deauthenticatedEvent: {
    triggered: false,
    message: ''
  },
  newStartMessage: '',
}
